import { render } from "./Skeleton.vue?vue&type=template&id=fb2398f8"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"

import "./Skeleton.vue?vue&type=style&index=0&id=fb2398f8&lang=scss"
script.render = render

export default script